// VIDEO FOR MOBILE

jQuery(document).ready(function ($) {

    $('.responsive-vid').removeAttr('height').removeAttr('width');

  if ( (document.body.clientWidth >= 480) && $('#video-viewport').length ) {
    $('#video-viewport').attr('autoplay', true);
    document.getElementById('video-viewport').play();
  }

  $(window).resize(function() {
    if ( (document.body.clientWidth >= 480) && $('#video-viewport').length ) {
    $('#video-viewport').attr('autoplay', true);
    document.getElementById('video-viewport').play();
    }
  });

});
